export const WHO_SIGNS_TYPES = {
	JUST_ME: 1,
	ME_AND_OTHERS: 2,
	OTHERS: 3,
};

export const IMPORTED_LEGACY_SIGNATURE = 'IMPORTED_LEGACY_SIGNATURE';
